<template>
    <div class="hello">


        <!--<div v-if="!showProgress">-->
            <!--Showing the {{ isTournamentActive ? "currently active" : "recently ended"}} <elv-boost-icon :boost="relic"/> tournament, {{ isTournamentActive ? "that ends on" : "that ended on" }}: {{endsOn}}</br>-->
        <!--</div>-->

        <div class="row">
            <div class="col-sm-9">
                <h1>{{ $t('site.common.tournaments') }}</h1>
            </div>
            <div class="col-sm-3">

                <v-select
                        :items="tournamentList"
                        v-model="selectedTournamentInfo"
                        item-display="tournamentId"
                        label="Select Report Date"
                        single-line
                        dense
                        :hint="$t('site.common.date')"
                        persistent-hint
                >
                    <template slot="selection" slot-scope="data">
                        <v-chip
                                @input="data.parent.selectItem(data.item)"
                                :selected="data.selected"
                                class="chip--select-multi"
                                key="tournamentId"
                        >
                            <v-avatar>
                                <elv-boost-icon :boost="data.item.relic"></elv-boost-icon>
                            </v-avatar>
                            {{ data.item.endsOn | moment('ll') }}
                        </v-chip>
                    </template>

                    <template slot="item" slot-scope="data">
                        <template v-if="typeof data.item !== 'object'">
                            <v-list-tile-content v-text="data.item"></v-list-tile-content>
                        </template>
                        <template v-else>
                            <v-list-tile-avatar>
                                <elv-boost-icon :boost="data.item.relic"></elv-boost-icon>
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                                <v-list-tile-title>{{data.item.tournamentId | moment('ll') }}</v-list-tile-title>
                                <!--<v-list-tile-sub-title v-html="(data.item.fellowship||'No Fellowship') + ', ' + data.item.serverName + ', ' + data.item.currScore"></v-list-tile-sub-title>-->
                            </v-list-tile-content>
                        </template>
                    </template>
                </v-select>
            </div>
        </div>

        <div v-if="viewAsPlayer.username && yourTournament" class="row">
            <h2>{{ $t('site.common.yourServer') }} ({{viewAsPlayer.serverName}})</h2>

            <div class="col-sm-3">
                <div class="panel">
                    <div class="panel-header panel-controls"><h3><i class="fas fa-server"></i> <strong><elv-server-name :server="yourTournament.server"></elv-server-name></strong><small style="text-align: right; float:right;"><relative-time-formatter :time="yourTournament.updatedAt"></relative-time-formatter></small></h3></div>
                    <elv-tournament-fs-table :tournament="yourTournament"></elv-tournament-fs-table>
                </div>
            </div>

            <div class="col-sm-6">
                <div class="panel">
                    <div class="panel-header panel-controls"><h3><i class="fas fa-server"></i> <strong><elv-server-name :server="yourTournament.server"></elv-server-name></strong><small style="text-align: right; float:right;"><relative-time-formatter :time="yourTournament.updatedAt"></relative-time-formatter></small></h3></div>
                    <elv-tournament-player-table :players="tournamentPlayers" :server="viewAsPlayer.server"></elv-tournament-player-table>
                </div>
            </div>
        </div>

        <div v-if="!viewAsPlayer.username" class="row">
            <div class="col-md-6">
                <div class="panel">
                    <div class="panel-content bg-secondary">
                        <h2>{{ $t('site.playerSelection.enterYourUsernameToGetStarted') }}</h2>
                        <elv-player-search-box :emitViewAsPlayer="true"></elv-player-search-box>
                        <small>{{ $t('site.playerSelection.thisIsNotASignup') }}</small>
                    </div>
                </div>
            </div>
        </div>


        <h2>{{ $t('site.common.allServers') }}</h2>
        <v-progress-linear :indeterminate="true" v-show="showProgress"></v-progress-linear>
        <div class="row">
            <div v-for="tournament in selectedTournaments">
                <div class="col-sm-3">
                    <div class="panel">
                        <div class="panel-header panel-controls"><h3><i class="fa fa-server"></i> <strong><elv-server-name :server="tournament.server"></elv-server-name></strong><small style="text-align: right; float:right;"><relative-time-formatter :time="tournament.updatedAt"></relative-time-formatter></small></h3></div>
                        <elv-tournament-fs-table :tournament="tournament"></elv-tournament-fs-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import ElvBoostIcon from '@/components/ElvBoostIcon';
    import ElvTournamentFsTable from '@/components/ElvTournamentFsTable';
    import ElvServerName from '@/components/ElvServerName';
    import RelativeTimeFormatter from '@/components/RelativeTimeFormatter';
    import _ from 'lodash';
    let elvenStats = require('../lib/elven-stats');
    import axios from 'axios';
    import ElvTournamentPlayerTable from "@/components/ElvTournamentPlayerTable";
    import ElvPlayerSearchBox from "@/components/ElvPlayerSearchBox";

    export default {
        name: 'Tournaments',
        components: {
            ElvPlayerSearchBox,
            ElvTournamentPlayerTable,
            ElvTournamentFsTable,ElvServerName, ElvBoostIcon, RelativeTimeFormatter },
        props: ['viewAsPlayer'],
        data () {
            return {
                selectedTournamentInfo: {},
                selectedTournaments: [],
                tempTournament: [],
                tournamentList: [],
                yourTournament: null,
                tournamentPlayers: [],
                relic: "",
                endsOn: "",
                isTournamentActive: true,
                showProgress: true,
            }
        },
        mounted() {
            this.getTournamentList();

            Event.$on("viewAsPlayer", (data) => {
                console.log("viewAsPlayer received in tournaments.vue");
                this.getTournamentList();
            });
        },
        methods: {
            getTournamentList: function() {
                axios.get(`/api/tournaments`).then( (response) => {
                    this.tournamentList = response.data;
                    this.selectedTournamentInfo = this.tournamentList[0];
                    //console.log( "TOURNAMENT LISTS:", this.tournamentList);
                }).catch( (err) => {
                    console.error(err);
                })
            }
        },
        watch: {
            selectedTournamentInfo: function(newVal) {
                if(!this.selectedTournamentInfo || !this.selectedTournamentInfo.tournamentId) {
                    console.log("skipping active tournament id not set");
                    return;
                }
                this.showProgress =true;
                axios.get(`/api/tournaments/*/${this.selectedTournamentInfo.tournamentId}`).then(response => {
                    this.selectedTournaments = _.sortBy(response.data, "server");
                    //console.log(JSON.stringify(response.data, null, 3));
                    // this.tempTournament = this.selectedTournaments[0];
                    // this.tournamentId = _.first(this.selectedTournaments).tournamentId;
                    // this.endsOn = moment( this.tournamentId ).format("dddd, MMMM D");
                    // this.isTournamentActive = moment.utc(this.tournamentId).hour(18).minute(0).isAfter( moment() );
                    // this.relic = _.first(this.selectedTournaments).relic;
                    this.showProgress = false;

                    if( this.viewAsPlayer && this.viewAsPlayer.server  ) {
                        this.yourTournament = _.find(this.selectedTournaments, {server: this.viewAsPlayer.server})
                    }
                });

                if( this.viewAsPlayer && this.viewAsPlayer.server ) {
                    axios.get(`/api/tournaments/players/${this.viewAsPlayer.server}/${this.selectedTournamentInfo.tournamentId}`).then(response => {
                        //console.log( response.data);
                        this.tournamentPlayers = response.data;
                    }).catch( (err) => {
                        console.error(err);
                    });
                }
            }
        },
        computed: {
            headers: {
                get: function () {
                    return [
                        {
                            text: this.$i18n.t('site.common.fellowship'),
                            align: 'left',
                            sortable: false,
                            value: 'fellowship'
                        },
                        {text: this.$i18n.t('site.common.score'), value: 'points', sortable:true},
                    ];
                }
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Tournaments.vue